export const localizationNamespaces = ["common", "components", "welcome", "surveys"]
